<template>
  <div class="aob-head">
    <ul class="list">
      <li class="flex-w1">
        <div class="chars-area">
          <div class="il-logo"></div>
          <div class="il-bg"></div>
          <b>Internal Logistics</b>
        </div>
      </li>
      <li v-for="(item, index) in headApiItems" :key="index">
        <h2 class="h-title">{{ item.cfgPageIlHeader.columName }}</h2>
        <ul class="s-list">
          <li @click="$emit('onPickFreq', item)">
            <h4>Pick Freq.</h4>
            <div class="b">
              <span class="strong">
                {{
                  item.cfgPageIlKpiColumns.length == 0
                    ? 0
                    : item.cfgPageIlKpiColumns[0].frequency
                }}
              </span>
              {{
                item.cfgPageIlKpiColumns.length == 0
                  ? 0
                  : item.cfgPageIlKpiColumns[0].cfgPageIlKpi.kpiTarget
              }}
            </div>
          </li>
          <li @click="$emit('onTimeDelivery', item)">
            <h4>ODR</h4>
            <div class="b">
              <span class="strong">
                {{
                  item.cfgPageIlKpiColumns.length == 0
                    ? 0
                    : item.cfgPageIlKpiColumns[1].frequency
                }}
              </span>
              {{
                item.cfgPageIlKpiColumns.length == 0
                  ? 0
                  : item.cfgPageIlKpiColumns[1].cfgPageIlKpi.kpiTarget
              }}
            </div>
          </li>
        </ul>
      </li>

      <li class="flex-w2 -px">
        <h2 class="h-title">Summary</h2>
        <div class="chars-area">
          <div>
            <i class="iconfont icon-chart font-big"></i>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup>
  import { defineProps, computed } from 'vue'
  const props = defineProps({
    data: {
      type: Array,
      default: () => [],
    },
  })

  const headApiItems = computed(() => props.data)
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .aob-head {
    padding: 0;
    height: 100px;
    background-color: #3c5271;
    color: #fff;
    .h-title {
      font-size: 20px;
      text-align: center;
      color: @white;
      margin: 5px 0;
      padding: 0;
      line-height: 1.2;
    }
    .list {
      display: flex;
      align-items: center;
      > li {
        flex: 1;
        border-right: 1px solid @white1;
        box-shadow: 1px 0 0 @black1;
        &.flex-w1 {
          flex: 0 0 150px;
        }
        &.flex-w2 {
          flex: 0 0 200px;
        }
      }
      .flex-w1 {
        height: 94px;
        flex: 0 0 150px;
      }
      .il-logo {
        background: url('../../assets/1.png') no-repeat center;
        width: 60px;
        height: 60px;
        background-size: 75%;
        border-radius: 50%;
        margin-top: -10px;
        position: relative;
        z-index: 1;
      }
      .il-bg {
        display: block;
        width: 60px;
        height: 60px;
        position: absolute;
        background: -webkit-linear-gradient(top, #3d6aa9, #2881a7);
        border-radius: 10px;
        z-index: 0;
        top: 50%;
        margin-top: -35px;
      }
      .chars-area {
        position: relative;
        width: 90px;
        height: 90px;
        line-height: 90px;
        text-align: center;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        b {
          position: absolute;
          line-height: 1;
          font-size: 14px;
          bottom: 5px;
          left: 0;
          right: 0;
          color: #aeb6c1;
          font-weight: normal;
        }
      }
      .flex-w2 .chars-area {
        width: 50px;
        height: 50px;
        line-height: 50px;
        .font-big {
          font-size: 48px;
        }
      }
    }
    .s-list {
      display: flex;
      padding: 0 5px 5px;
      border-top: 1px solid @white1;
      > li {
        flex: 1;
        align-items: center;
        border-right: 1px solid @white1;
        padding: 0 5px;
        color: @white6;
        &:last-child {
          border: none;
        }
        h4 {
          font-size: 12px;
          color: @white6;
          margin: 0;
          padding: 5px 0;
        }
        .b {
          text-align: right;
          font-size: 18px;
          .strong {
            font-weight: 800;
            font-size: 18px;
            color: #fff;
            position: relative;
            &:after {
              content: '';
              font-weight: normal;
              font-size: 14px;
              padding-left: 3px;
              padding-right: 3px;
              vertical-align: middle;
              display: inline-block;
              border-right: 1px solid @white2;
              height: 15px;
            }
          }
        }
      }
    }
  }
</style>
